module.exports = __webpack_public_path__ + "static/media/special@3x.cc3f0cf9.png";